import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-work-list",
  templateUrl: "./work-list.component.html",
  styleUrls: ["./work-list.component.scss"],
})
export class WorkListComponent implements OnInit {
  order: number[] | undefined;

  images = [
    {
      img: "assets/img/random/random_01.webp",
      description: "Logo op verpakking voor Grailer G2 zakmes",
    },
    {
      img: "assets/img/random/random_02.webp",
      description: "Have a knives day stickers voor Knivesandtools",
    },
    {
      img: "assets/img/random/random_03.webp",
      description: "Verpakking design voor Skerper slijpproducten",
    },
    {
      img: "assets/img/random/random_04.webp",
      description: "Logo op Eden Takara Japanse keukenmessen",
    },
    {
      img: "assets/img/random/random_05.webp",
      description: "Verpakking voor Eden Classic Damast keukenmessen collectie",
    },
    {
      img: "assets/img/random/random_06.webp",
      description: "Logo op Eden Dento Japanse keukenmessen",
    },
    {
      img: "assets/img/random/random_01.webp",
      description: "Verpakking voor Grailer G2 zakmes",
    },
    {
      img: "assets/img/random/random_08.webp",
      description: "Label Habibah Fashion",
    },
    {
      img: "assets/img/random/random_09.webp",
      description: "Letterpress card Habibah Fashion",
    },
    {
      img: "assets/img/random/random_10.webp",
      description: "Serious Summer Sale website banner",
    },
    {
      img: "assets/img/random/random_11.webp",
      description: "Logo voor Zuboo e-commerce concept",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_12.webp",
      description: "Logo voor Incentive reisorganisatie",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_13.webp",
      description: "Illustratie Plixy Payment",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_14.webp",
      description: "Logo Takara",
    },
    {
      img: "assets/img/random/random_15.webp",
      description: "Logo Osmose multicultureel adviesbureau",
    },
    {
      img: "assets/img/random/random_16.webp",
      description: "Knivesandtools magazine spread",
    },
    {
      img: "assets/img/random/random_17.webp",
      description: "Logo voor MyGoodz e-commerce concept",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_18.webp",
      description: "Inpakpapier voor Habibah Fashion",
    },
    {
      img: "assets/img/random/random_19.webp",
      description: "Logo voor 'Looking for Groups' platform",
    },
    {
      img: "assets/img/random/random_20.webp",
      description: "Have a knives day sticker voor Knivesandtools sticker-pack",
    },
    {
      img: "assets/img/random/random_21.webp",
      description: "Inpakpapier voor Knivesandtools",
    },
    {
      img: "assets/img/random/random_22.webp",
      description: "Stempel logo voor Knivesandtools zakmessen nieuwsbrief",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_23.webp",
      description: "Commplot logo op achtergrond",
    },
    {
      img: "assets/img/random/random_24.webp",
      description: "Spread Triple P Brochure 'Passion for Performance",
    },
    {
      img: "assets/img/random/random_25.gif",
      description: "Giphy sticker Swipe Up voor Knivesandtools",
    },
    {
      img: "assets/img/random/random_25.gif",
      description: "Cover Next Level Gear, Knivesandtools magazine",
    },
    {
      img: "assets/img/random/random_27.webp",
      description: "Symbolen voor verpakking Eden verrekijkers",
    },
    {
      img: "assets/img/random/random_28.webp",
      description: "Logo Eden Sugoi Japanese keukenmessen collectie",
    },
    {
      img: "assets/img/random/random_29.webp",
      description: "N of Z",
    },
    {
      img: "assets/img/random/random_30.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_32.webp",
      description: "'Sorry' ansichtkaart Knivesandtools",
    },
    {
      img: "assets/img/random/random_33.webp",
      description: "Spread brochure keukenmessen line-ups",
    },
    {
      img: "assets/img/random/random_34.gif",
      description: "Giphy sticker Knivesandtools",
    },
    {
      img: "assets/img/random/random_35.gif",
      description: "Packaging design voor Skerper Basic slijpset",
    },
    {
      img: "assets/img/random/random_36.gif",
      description: "404 page animatie Knivesandtools website",
    },
    {
      img: "assets/img/random/random_37.webp",
      description: "Banner ICT Service van Brainforce",
    },
    {
      img: "assets/img/random/random_38.webp",
      description: "Banner ICT Service van Brainforce",
    },
    {
      img: "assets/img/random/random_39.webp",
      description: "Banner ICT Service van Brainforce",
    },
    {
      img: "assets/img/random/random_40.webp",
      description: "Banner ICT Service van Brainforce",
    },
    {
      img: "assets/img/random/random_41.webp",
      description: "Eden Dento logo op Japans keukenmes",
    },
    {
      img: "assets/img/random/random_42.webp",
      description: "Eden Classic Damast gravering",
    },
    {
      img: "assets/img/random/random_43.gif",
      description: "Illustraties voor Plixy betaal service",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_44.webp",
      description: "Untitled ",
    },
    {
      img: "assets/img/random/random_45.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_46.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_47.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_48.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_49.webp",
      description: "Categorie illustratie voor Knivesandtools campagne",
    },
    {
      img: "assets/img/random/random_50.webp",
      description: "Illustratie voor Stand-up comedy avonden",
    },
    {
      img: "assets/img/random/random_51.webp",
      description: "Logo voor jaarlijks 'Have a knives day' festival",
    },
    {
      img: "assets/img/random/random_52.gif",
      description: "Logo voor hardloop lab",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_53.gif",
      description: "Social content voor hardloop lab",
      concept: "concept",
    },
    {
      img: "assets/img/random/random_54.gif",
      description: "Logo voor 'Duchenne Parents Project'",
      concept: "concept",
    },
  ];

  ngOnInit(): void {
    this.order = this.images.map((n, index) => index); //create an array [0,1,2,3..]
    this.order.sort((a, b) => (Math.random() > 0.5 ? 1 : -1)); //shuffle the array
  }
}
